(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["dollie-truffle-landing"] && !Shopify.designMode) return;
  try {
    
function initTruffleLanding() {
  document.querySelectorAll('.tm-v2').forEach(function (section) {
    if (section.dataset.stickyReady) return;
    section.dataset.stickyReady = 'true';
    var hero = section.querySelector('.tm-hero-shell');
    if (!hero || !('IntersectionObserver' in window)) return;
    var observer = new IntersectionObserver(function (entries) {
      section.classList.toggle('tm-sticky-on', !entries[0].isIntersecting && entries[0].boundingClientRect.top < 0);
    });
    observer.observe(hero);
  });
}
initTruffleLanding();
document.addEventListener('shopify:section:load', initTruffleLanding);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["dollie-truffle-recipes"] && !Shopify.designMode) return;
  try {
    
const initTruffleDescriptions = () => {
  document.querySelectorAll('.dtr-full-description').forEach(details => {
    if (details.dataset.responsiveReady) return;
    details.dataset.responsiveReady = 'true';
    const desktop = window.matchMedia('(min-width: 768px)');
    details.open = desktop.matches;
    desktop.addEventListener('change', event => { details.open = event.matches; });
  });
};
initTruffleDescriptions();
document.addEventListener('shopify:section:load', initTruffleDescriptions);

  } catch(e) { console.error(e); }
})();
})();
